import lowerCase from 'lodash/lowerCase';
import startCase from 'lodash/startCase';

export const toLabelCase = (value: string): string => {
  return startCase(lowerCase(value));
};
